export default {
  typeValues: [],
  activityValues: [],
  allowTopsideValues: [],
  slViewValues: [],
  allowEntryValues: [],
  allowTransferValues: [],
  isFetchingInitialDataForAddModal: false,
};
